import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavigationBar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./styles/main.scss";
import "./styles/res.scss";
import OurSolutions from "./components/OurSolutions";
import Contact from "./components/Contact";

function App() {
  return (
    <Router>
      <div className="App d-flex flex-column min-vh-100">
        <NavigationBar />
        <main className="flex-grow-1" style={{ paddingTop: "76px" }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" exact element={<Services />} />
            <Route path="/services/:serviceKey" exact element={<Services />} />
            <Route path="/our-solutions" exact element={<OurSolutions />} />
            <Route
              path="/our-solutions/:solutionKey"
              exact
              element={<OurSolutions />}
            />
            <Route path="/contact" exact element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
